<gameday-direct-header
  [loggedIn]="isAuthorized | async"
  [username]="username | async"
></gameday-direct-header>
<div
  *ngIf="isLoading | async"
  class="c-loader" [class.hidden]="!(isAuthorized | async)"
>
</div>
<router-outlet></router-outlet>
<spr-footer [expandable]="true" [sticky]="true" [links]="footerLinks"></spr-footer>

<gameday-direct-classification-notice-modal
  [show]="showClassificationModal"
  (closeModal)="closeClassificationModal()">
</gameday-direct-classification-notice-modal>
